export const PAYMENT_STATUS = {
  AUTHORIZED: 'AUTHORIZED',
};
